<template>
    <div class="teaserMobile">
        <div class="over-lay"></div>
        <div class="bodyContent">
            <div class="smallcontainer" v-if="teaserObject">
                <div class="headsmall">
                    <img alt="TONE Networks" class="logosl" src="../assets/coloredlogotone.png" />
                    <a :href="'/mytone'" @click.prevent="$router.push('/mytone')" ><img alt="TONE home" class="topbtn" src="../assets/TONE_HOME_ICON.png" /></a>
                    <img alt="" src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg" class="grad" />
                </div>
                <h1>Hey there, {{teaserObject.firstName}}</h1>
                <p>Here are your TONE Teasers - videos selected just for you and personalized to your interests.</p>
                <a :href="teaserObject.video1UrlKey" class="lglink" @click.prevent="$router.push(teaserObject.video1UrlKey)">{{teaserObject.video1Key}}</a>
                <a :href="teaserObject.video1UrlKey" @click.prevent="$router.push(teaserObject.video1UrlKey)"><img :alt="teaserObject.video1Key" class="video" :src="teaserObject.video1ImgKey" /></a>
                <br />
                <a :href="teaserObject.video2UrlKey" class="lglink" @click.prevent="$router.push(teaserObject.video2UrlKey)">{{teaserObject.video2Key}}</a>
                <br />
                <a :href="teaserObject.video2UrlKey" @click.prevent="$router.push(teaserObject.video2UrlKey)"><img :alt="teaserObject.video2Key" class="video" :src="teaserObject.video2ImgKey" ></a>
                <br />
                <div class="purpletextcontainer" v-if="teaserObject.talkTitle || teaserObject.expertName">
                    <br>
                    <img alt="" class="blowhorn" src="https://s3.amazonaws.com/tone-assets/images/templates/weekly-emails/img_mic.png" />
                    <p>{{teaserObject.quotesValue}}</p>
                    <a> - {{teaserObject.authorNameValue}}</a>
                    <hr />
                    <h3 v-if="teaserObject.talkTitle || teaserObject.expertName">Upcoming Events</h3>
                    <div v-if="teaserObject.talkTitle" class="entryholder"> <img :alt="teaserObject.talkTitle" :src="teaserObject.talkImgUrl" />
                        <h4>Tone Talk:{{teaserObject.talkTitle}}</h4>
                        <p>
                            {{teaserObject.talkLongDescription}}<br><br>{{teaserObject.talkStartDate}}</p>
                        <a :href="`/event/${teaserObject.talkEventId}`" @click.prevent="$router.push(`/event/${teaserObject.talkEventId}`)">Add to Calendar</a></div>
                    <div class="entryholder" v-if="teaserObject.expertName"> <img :alt="teaserObject.expertName" :src="teaserObject.eventImgUrl" />
                        <h4>Tone Live: {{teaserObject.expertName}}</h4>
                        <p>
                            {{teaserObject.eventLongDescription}}<br><br>{{teaserObject.eventStartDate}}</p>
                        <a :href="`/event/${teaserObject.eventEventId}`" @click.prevent="$router.push(`/event/${teaserObject.eventEventId}`)">Add to Calendar</a></div>
                </div>
                <br>
                <img class="advertimg" :src = "teaserObject.funniesValue"/>
                <div class="graylastext">
                    In the mood of something else?
                </div>
                <a :href="'/mytone'" @click.prevent="$router.push('/mytone')" ><img alt="TONE home" class="topbtn lastlogobutton" src="../assets/TONE_HOME_ICON.png" /></a>
                <br />
                <h3 class="pinktext">Set the tone of your life</h3>
                <p class="lastpara">- The TONE Team</p>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'toneteasermobile',
        data: function () {
            return {
                success: false,
                successMsg: '',
                teaserObject: null,
                appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation'
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getOriginalVideoCode', 'getToneTeasers'
            ])
        },
        methods: {
        },
        mounted: function () {
            let self = this
            if (self.user && navigator.userAgent.indexOf('gonative') > -1) {
                let info = {userId: self.user.userId}
                let jsonFile = ''
                if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                    jsonFile = 'sidebar_auth_corp.json'
                } else {
                    jsonFile = 'sidebar_auth.json'
                }
                var json = JSON.stringify(info)
                window.location.href = `gonative://registration/send?customData=${encodeURIComponent(json)}`
                // Get auth Navigation bar
                $.getJSON(`${self.appNavigationURL}/${jsonFile}`, function (data) {
                    console.log('side navigation (uath) returned', data)
                    var json = JSON.stringify(data)
                    window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json)
                }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                    // Get auth Bottom bar - not for android
                    setTimeout(function () {
                        $.getJSON(`${self.appNavigationURL}/bottomNav_auth.json`, function (data) {
                            console.log('bottom navigation (auth) returned', data)
                            var json = JSON.stringify(data)
                            window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json)
                        }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                    }, 500)
                }
                // Get Teaser Data
                self.$store.dispatch('GETTONETEASER', self.user.userId).then(() => {
                    self.teaserObject = self.getToneTeasers
//                    console.log('teaser object', self.teaserObject)
                })
            } else {
                self.$router.push('/')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .smallcontainer {
        max-width: 420px;
        margin: auto;
        font-size: 18px;
    }

    p {
        font-size: 18px;
        font-weight: 500;
    }

    a.lglink {
        font-size: 20px;
        font-weight: 500;
        color: #000;
        text-decoration: underline;
        margin: 30px 0 20px;
        display: block;
        cursor: pointer;
    }

    .purpletextcontainer a {
        display: block;
        margin: 20px 0 40px;
    }

    .purpletextcontainer p {
        color: #8e628b;
        font-style: italic;
        font-size: 22px;
        font-weight: 900;
    }

    .purpletextcontainer hr {
        border-color: #f2617d;
    }
    h3 {
        color: #f0617d;
    }

    .purpletextcontainer h3 {
        font-weight: 900;
        color: #8e628b;
    }

    .entryholder {
        text-align: left;
    }

    .entryholder p {
        font-size: 16px;
        font-style: normal;
        font-weight: normal;
        color: #000;
    }

    .entryholder > a {
        text-align: center;
    }

    .graylastext {
        font-size: 16px;
    }
    img.video {
        max-width: 90%;
        margin: auto;
        display: block;
    }

    img {
        max-width: 100%;
    }

    .graylastext {
        margin: 50px 0 30px;
    }

    .bodyContent {
        padding-bottom: 50px;
    }

    img.blowhorn {
        max-width: 100%;
    }

    .entryholder {
        margin-top: 20px;
    }

    .entryholder p {
        margin: 0 0 40px;
    }

    .entryholder img {
        margin: 0 0 20px;
    }
    img.grad {
        max-width: 100%;
    }

    img.topbtn {
        float: right;
        padding: 10px;
        border: 1px solid #f0617d;
        border-radius: 10px;
    }

    img.logosl {
        float: left;
        margin-top: 10px;
    }

    .smallcontainer {
        padding-top: 50px;
        padding-left: 20px;
        padding-right: 20px;
    }
    img.topbtn.lastlogobutton {
        float: none !important;
    }
</style>



// WEBPACK FOOTER //
// TeaserMobile.vue?7ae17795